export class HttpDomainExtractor {
  /**
   * Extracts the domain and path from a given URL.
   * @param url - The input URL string.
   * @returns An object containing the domain and path, or null if the URL is invalid.
   */
  static extractDomain(url: string, startWith = 'http'): { domain: string; path: string } {
    try {
      const parsedUrl = new URL(url);
      return {
        domain: `${parsedUrl.protocol}//${parsedUrl.hostname}`,
        path: parsedUrl.pathname,
      };
    } catch (error) {
      console.error('Invalid URL:', url, error);
      return { domain: '', path: '' };
    }
  }
}

// // Example usage:
// const input1 = 'document/d/1It9YlPxEKVZjX0k0yF0F1eCVlrJCrnQu/edit';
// const input2 = 'https://docs.google.com/document/d/1It9YlPxEKVZjX0k0yF0F1eCVlrJCrnQu/edit';

// console.log(HttpDomainExtractor.extractDomain(input1));
// // Output: { domain: 'https://docs.google.com', path: '/document/d/1It9YlPxEKVZjX0k0yF0F1eCVlrJCrnQu/edit' }

// console.log(HttpDomainExtractor.extractDomain(input2));
// // Output: { domain: 'https://docs.google.com', path: '/document/d/1It9YlPxEKVZjX0k0yF0F1eCVlrJCrnQu/edit' }
